import { isNil } from '@lucidlink/tscore';
import { LockRequest } from './messages/lock';
import { UnlockByNodeIdRequest } from './messages/unlock-node-id';
import { UnlockRangesRequest } from './messages/unlock-ranges';
export class KeyRangeLockingProxy {
    client;
    serverSession;
    keyRangeLockingServicePath;
    constructor(fsId, client, serverSession) {
        this.client = client;
        this.serverSession = serverSession;
        this.keyRangeLockingServicePath = `/${fsId}/KeyRangeLockingService`;
    }
    async lock(lockParams) {
        const req = new LockRequest(lockParams, this.keyRangeLockingServicePath);
        const res = await this.sendRequest(req);
        return res.result.success;
    }
    async unlockAllLocksHeldByNode(nodeId) {
        const req = new UnlockByNodeIdRequest(nodeId, this.keyRangeLockingServicePath);
        await this.sendRequest(req);
    }
    async unlockRanges(unlockRanges) {
        const req = new UnlockRangesRequest(unlockRanges, this.keyRangeLockingServicePath);
        await this.sendRequest(req);
    }
    async establishSession() {
        if (isNil(this.serverSession)) {
            return undefined;
        }
        return await this.serverSession.getSessionToken();
    }
    async sendRequest(msg) {
        const sessionToken = await this.establishSession();
        return (await this.client.sendRequest(msg, sessionToken));
    }
}
